declare global {
  interface Window {
    gtag?: (
      command: 'config' | 'event' | 'js',
      targetId: string | Date,
      config?: Record<string, unknown>
    ) => void;
    dataLayer?: unknown[];
    fbq?: (command: string, event: string, params?: Record<string, unknown>) => void;
  }
}

export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, unknown>
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

export const trackPageView = (url: string, title: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Send an explicit GA4 page_view on each SPA route change. page_location is
    // included because GA4 "Page load" conversion conditions match on the full URL
    // (e.g. the Google Ads conversion imported from "Page load: book/thank-you").
    window.gtag('event', 'page_view', {
      page_path: url,
      page_location: window.location.href,
      page_title: title,
      send_to: 'G-EM7QLQLR4K',
    });
  }
};

export const trackButtonClick = (buttonName: string, location: string) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: location,
  });
};

export const trackFormSubmission = (formName: string, success: boolean) => {
  trackEvent('form_submission', {
    form_name: formName,
    success: success,
  });
};

export const trackCalendlyOpen = (source: string) => {
  trackEvent('calendly_open', {
    source: source,
  });
};

export const trackOutboundLink = (url: string, linkText: string) => {
  trackEvent('outbound_link_click', {
    url: url,
    link_text: linkText,
  });
};

export const trackUserEngagement = (action: string, details?: Record<string, unknown>) => {
  trackEvent('user_engagement', {
    engagement_action: action,
    ...details,
  });
};
